import axios from "axios";

const isLatest = ref(true);

export function useVersion() {
  const version = __APP_VERSION__;
  const versionFile = "/version.json"; // Must be the same as file created by deployment script

  /**
   * Checks if current bundle version is latest.
   */
  async function checkIsLatest(): Promise<boolean> {
    const latestVersion = await getLatestVersion();
    const latestWeight = countVersionWeight(latestVersion);
    const currentWeight = countVersionWeight(version);
    const is = latestWeight <= currentWeight;
    isLatest.value = is;
    return is;
  }

  /**
   * Loads latest version from some external source (file actually in this case).
   */
  async function getLatestVersion(): Promise<string> {
    const headers = { "Cache-Control": "no-cache" };
    return axios.get(versionFile, { headers }).then((response) => response.data.version ?? "");
    // intentionally no catch() -> let's log erros into console
  }

  /**
   * Works only with none or one char at the end of version name. With two chars, it'll not work.
   */
  function countVersionWeight(version: string): number {
    const str = version.replace(/\./g, "");
    const lastChar = str.slice(-1);

    let weight = parseInt(str);
    if (isNaN(parseInt(lastChar))) {
      weight += lastChar.charCodeAt(0) / 100;
    }

    return weight;
  }

  function logIntoConsole(): void {
    // If you change this, check also Sentry setup. There might be regex matching this log that needs to be updated.
    console.log("%c" + version, "padding: 4px 8px; color: #fff; background: #32C380; border-radius: 5px");
  }

  function startAutocheck(): void {
    const checkInterval = 900000; // 900000 === 15 minutes
    setInterval(() => checkIsLatest(), checkInterval);
    // Check immediately when the user returns to the tab rather than waiting up to 15 minutes.
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        checkIsLatest();
      }
    });
  }

  return {
    version,
    isLatest,
    checkIsLatest,
    logIntoConsole,
    startAutocheck,
  };
}
